/**额度变动类型 */
export enum QuotaTypeEnum {
  /**额度发放 */
  QuotaAllocation = 1,
  /**额度回收 */
  QuotaRecycle = 2,
  /**额度消费 */
  QuotaConsumption = 3,
  /**额度回退 */
  QuotaRollback = 4,
}
